import { SITE_URL } from '../../constants'
import { buildCaseStudySchema } from '../../builders/caseStudy'
import { PageMeta } from '../../types'

const description =
  '地方の移動課題を解決する住民マッチング型MaaSアプリ「meemo」のUX/UI設計・クラウドネイティブ開発を担当。文字入力ゼロの高齢者向けUX設計と高速CI/CDで、実証実験でユーザーから高評価を獲得したオムロンとのアプリ開発事例です。'

const ogpImg = 'https://aitria.co.jp/images/img/cases/meemo/ogp_meemo.png'

export const meemoPageMeta: PageMeta = {
  title: '日本初のMaaSアプリ「meemo」開発｜高齢者UX×クラウドネイティブの事例 | Aitria（アイトリア）',
  description,
  keyword: 'UX/UI モバイルアプリ開発 デジタルトランスフォーメーション クラウドサービス',
  image: ogpImg,
  url: `${SITE_URL}/cases/meemo/`,
}

export const meemoSchema = buildCaseStudySchema({
  slug: 'meemo',
  pageTitle: meemoPageMeta.title,
  description: meemoPageMeta.description,
  headline: '日本初のMaaSアプリ開発で、地方の高齢化に伴う課題の解決に貢献',
  alternativeHeadline: 'オムロン ソーシアルソリューションズ株式会社',
  primaryImage: ogpImg,
  images: [ogpImg, 'https://aitria.co.jp/images/img/cases/meemo/top.webp'],
  clientName: 'オムロン ソーシアルソリューションズ株式会社',
  breadcrumbLabel: '日本初のMaaSアプリ開発で、地方の高齢化に伴う課題の解決に貢献',
})
